
import React, { useEffect, useState, } from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import Loader from "./loader";
import { AppContext } from "../../context/AppContext";
import ApiConfig from "../../api/ApiConfig";
import { multipartPostCallWithErrorResponse, PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import { ToastMsg } from "../TostMsg";
import NoDataFound from "./NodataFound";


const TestDataStatic = () => {
  const { sidebar, selectedDomainId } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);

  const [editId, setEditId] = useState('')

  const [showadd, setShowadd] = useState(false);


  const [isAutoUpdate, setIsAutoUpdate] = useState(false)

  const [moduleList, setModuleList] = useState([]);

  const initialModule = {
    module_by_display_name: '',
    module_by_description: "",
    module_by_name: "",
    update_icon_file: '',
    module_by_icon: ''
  }

  const [editModule, setEditModule] = useState(initialModule)



  const handleEditModule = (key, val) => {

    setEditModule(prev => ({
      ...prev,
      [key]: val
    }))

  }


  const getModuleList = () => {

    simpleGetCallWithErrorResponse(ApiConfig.GET_Module_STATIC + selectedDomainId).then((res) => {


      if (res?.json?.success) {

        setIsLoading(false)

        setModuleList(res?.json?.data)

      }

    })

  }




  useEffect(() => {


    getModuleList()


  }, [selectedDomainId])

  const updateModule = () => {

    setIsAutoUpdate(true)

    PostCallWithErrorResponse(ApiConfig.AUTO_UPDATE_MODULES).then((res) => {

      if (res?.json?.success) {

        setIsLoading(true)


        ToastMsg('success', res?.json?.message)

        getModuleList()

        setIsAutoUpdate(false)

      }

    })

  }


  return (
    <div className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div>
        <div className="role-content">
          <div className="sub-header-role d-flex justify-content-between">
            <h6 className="mt-2">Data Statistics</h6>
            {/* <button className="addSetting_btn" onClick={updateModule}
              disabled={isAutoUpdate}
            >
              Update Modules
            </button> */}
          </div>
          <div
            className="table-wrapper table-wrapper-2"
            style={{ height: "600px" }}
          >
            {
              isLoading ? <Loader /> :
                moduleList.length > 0 ?
                  <table style={{ marginBottom: "20px" }}>
                    <thead className="">
                      <tr className="firstTabelRow">
                        <th>Sr. No</th>
                        <th>Module Name</th>
                        <th>Test Case Count</th>

                      </tr>
                    </thead>
                    {moduleList.map((module, index) => (
                      <tr key={index} className="table-row-custom">
                        <td>{index + 1}</td>
                        <td>
                          <Link to={"/SubTestCaseStatistics/" + module.module_name}>{module.module_name}</Link>
                        </td>
                        <td>
                          {module.count}

                        </td>



                      </tr>
                    ))}
                  </table>
                  : <NoDataFound />
            }
          </div>
        </div>
      </div>


    </div>
  );
};
export default TestDataStatic;
